import { render, staticRenderFns } from "./fit_config.vue?vue&type=template&id=73047e84&scoped=true"
import script from "./fit_config.vue?vue&type=script&lang=js"
export * from "./fit_config.vue?vue&type=script&lang=js"
import style0 from "./fit_config.vue?vue&type=style&index=0&id=73047e84&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73047e84",
  null
  
)

export default component.exports